// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"541":"sidebar","562":"accounts","809":"account"}[chunkId] || chunkId) + "." + {"392":"1ec7af88","541":"b316ab65","562":"6345b575","809":"e193b0ed"}[chunkId] + ".chunk.js";
};